export default {
    getEmployeeList: (state) => {
        return state.employeeList;
    },
    getEmployeeListCount: (state) => {
        return state.employeeListCount;
    },
    getEmployeeMainFilter: (state) => {
        return state.employeeFilter.main_filter;
    },
    getEmployeeFilterFields: (state) => {
        return state.employeeFilter.fields;
    },
    getEmployeeModalOpen: (state) => {
        return state.employeeModalOpen;
    },
    getEmployeeIdAndEmployeeIndex: (state) => {
        return {
            employee_id: state.employee_id,
            employee_index: state.employee_index
        };
    },
}
